import "../public/style.css";
import App from './components/App.js';

import { createRoot } from 'react-dom/client';
const root = createRoot(document.getElementById('react-container'));
root.render(<App />);

console.log("hello Parcel!");